import { MutationOptions, useMutation } from 'react-query';

import { MAX_FILE_UPLOAD_BYTE, MAX_FILE_UPLOAD_MEGA_BYTE } from '@app/constants/UpLoadModal';
import { getFileBlobFromURL } from '@app/store/transport-layer/files';
import { postDocumentUpload } from '@app/store/transport-layer/upload/document/upload';

type UploadResult = { fileId: string; pdfArrayBuffer: ArrayBuffer; title?: string; url: string };
type UploadDraft = { url: string; title?: string };

export default function useTemplateDocumentFileUploadByUrl(
  options?: MutationOptions<UploadResult, Error, UploadDraft>
) {
  return useMutation<UploadResult, Error, UploadDraft>(async (uploadDraft: UploadDraft) => {
    const { fileId, url } = await postDocumentUpload({ url: uploadDraft.url });
    const blobFile = await getFileBlobFromURL(url);
    if (blobFile.size > MAX_FILE_UPLOAD_BYTE) {
      throw Error(
        `템플릿의 최대 크기는 ${MAX_FILE_UPLOAD_MEGA_BYTE}MB입니다.\n크기를 줄이거나 다른 문서로\n이용해 주세요.`
      );
    }
    const pdfArrayBuffer = await blobFile.arrayBuffer();
    return { fileId, pdfArrayBuffer, title: uploadDraft.title, url };
  }, options);
}
